class RootObjects {
  init (objects) {
    this.objects = objects
  }
  getObject(key) {
    return this.objects[key]
  }
}

export default new RootObjects()